<template>
    <div style="height: 100%">
        <div style="width: 100%">
            <el-row class="filter-bar" ref="filterBar">
                    <el-select v-model="formDatas.agyType" placeholder="类型" style="width: 120px;" size="mini"
                        @change="partserch" clearable>
                        <el-option label="小象全量" :value="1"></el-option>
                        <el-option label="傲举" :value="2"></el-option>
                        <el-option label="易宝通" :value="3"></el-option>
                    </el-select>
                    <el-input v-model="formDatas.specsSku" style="width: 140px;" size="mini"
                        placeholder="商品编码" clearable @keyup.enter.native="partserch"></el-input>
                    <el-input v-model="formDatas.specsName" style="width: 140px;" size="mini"
                        placeholder="商品名称" clearable @keyup.enter.native="partserch"></el-input>
                    <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="">搜索</el-button>
          
            <el-button type="success" size="mini" style=" " @click="BoxOpen">新增</el-button>
          </div>
        </el-row>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
                element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading"
                custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增/编辑弹窗 -->
            <el-drawer :wrapperClosable="false" :title="edit ? '编辑商品' : '新增商品'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div style="width: 100%; height: 100%; overflow-y: scroll; padding: 50px 50px 15px; overflow-x: hidden;">
                            <el-form-item label="类型" prop="agyType">
                                <el-select v-model="form.agyType" placeholder="请选择" style="width: 80%;">
                                    <el-option label="小象全量" :value="1"></el-option>
                                    <el-option label="傲举" :value="2"></el-option>
                                    <el-option label="易宝通" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="商品编码" prop="specsSku">
                                <el-input v-model="form.specsSku" style="width: 80%;" placeholder="请输入商品编码"></el-input>
                            </el-form-item>
                            <el-form-item label="商品名称" prop="specsName">
                                <el-input v-model="form.specsName" style="width: 80%;" placeholder="请输入商品名称"></el-input>
                            </el-form-item>
                            <el-form-item label="结算价格" prop="specsPriceSettlement">
                                <el-input v-model="form.specsPriceSettlement" style="width: 80%;" placeholder="请输入结算价格"></el-input>
                            </el-form-item>
                            <el-form-item label="销售价格" prop="specsNameSales">
                                <el-input v-model="form.specsNameSales" style="width: 80%;" placeholder="请输入销售价格"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">确 定</el-button>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import { getAjefGoodsYdList, addAjefGoodsYd, updateAjefGoodsYd, deleteAjefGoodsYd } from "../../api/api";
export default {
    name: "GoodsYd",
    components: {},
    data() {
        return {
            tableLoading: false,
            dialog: false,
            edit: false,
            tableHight: 520,
            totalCount: 0,
            form: {},
            rules: {
                agyType: [{ required: true, message: '请选择类型', trigger: 'change' }],
                specsSku: [{ required: true, message: '请输入商品编码', trigger: 'blur' }],
                specsName: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "agyType",
                    key: "agyType",
                    title: "类型",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const typeMap = { 1: '小象全量', 2: '傲举', 3: '易宝通' };
                        return typeMap[row.agyType] || '-';
                    },
                },
                {
                    field: "specsSku",
                    key: "specsSku",
                    title: "商品编码",
                    align: "center",
                    width: 180,
                },
                {
                    field: "specsName",
                    key: "specsName",
                    title: "商品名称",
                    align: "center",
                    width: 200,
                },
                {
                    field: "specsPriceSettlement",
                    key: "specsPriceSettlement",
                    title: "结算价格",
                    align: "center",
                    width: 120,
                },
                {
                    field: "specsNameSales",
                    key: "specsNameSales",
                    title: "销售价格",
                    align: "center",
                    width: 120,
                },
                {
                    field: "createusername",
                    key: "createusername",
                    title: "创建人",
                    align: "center",
                    width: 100,
                },
                {
                    field: "createtime",
                    key: "createtime",
                    title: "创建时间",
                    align: "center",
                    width: 160,
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 120,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: green"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ],
            tableData: [],
            formDatas: {
                agyType: '',
                specsSku: '',
                specsName: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.$nextTick(() => {
            this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                this.tableHight = calcTableHeight(this, val, 140);
            });
        },
    },
    created() {
        this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        this.getList();
    },
    methods: {
        getList() {
            this.tableLoading = true;
            getAjefGoodsYdList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data || [];
                this.totalCount = res.total || 0;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.getList();
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            this.getList();
        },
        BoxOpen() {
            this.dialog = true;
            this.edit = false;
            this.form = {};
        },
        handleEdit(row) {
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = JSON.parse(JSON.stringify(row));
            });
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除该商品吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                deleteAjefGoodsYd({ agyId: row.agyId }).then(res => {
                    if (res.data) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                        this.partserch();
                    }
                });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消",
                });
            });
        },
        SureBtn() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    const action = this.edit ? updateAjefGoodsYd : addAjefGoodsYd;
                    const msg = this.edit ? "编辑" : "新增";
                    this.$confirm(`是否确定要${msg}该商品吗?`, "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        action(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: `${msg}成功!`,
                                });
                                this.handleClose();
                                this.getList();
                            }
                        });
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
                }
            });
        },
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.form = {};
            this.$refs.formRef && this.$refs.formRef.resetFields();
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.ve-table-container {
    height: auto !important;
}
</style>
